import Vue from 'vue'
import Vuex from 'vuex'
import user from './user.module'
import auth from './auth.module'
import tasks from './tasks.module'
import goals from './goals.module'
import maps from './maps.module'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    auth,
    tasks,
    goals,
    maps
  }
})
